<script type="text/javascript">
import axios from 'axios'
import AppCalls from '../../pages/shiguangji/utils/appcall.js'
// App.vue中的ref引用
var refs
window.HBHGlobal = ''

// 根据Key从cookie中获取相应值
function getCookie(name) {
  var reg = new RegExp('(^| )' + name + '=([^;]*)(;|$)')
  var arr = document.cookie.match(reg)
  if (arr) {
    return name == 'Authorization' ? decodeURIComponent(arr[2]) : arr[2]
  } else {
    return null
  }
}

function getUrlDomainForShiguangji() {
  var urlDomain = ''
  if (
    process.env.VUE_APP_ENV == 'development' &&
    /.*\d{1,3}\.\d{1,3}\.\d{1,3}\.\d{1,3}.*/.test(process.env.VUE_APP_URL)
  ) {
    urlDomain = process.env.VUE_APP_URL + '/shiguangji/'
  } else {
    urlDomain = process.env.VUE_APP_URL + '/jhtools/shiguangji/'
  }
  return urlDomain
}
// 获取微信js-sdk配置接口URL
function getWxConfigUrl() {
  // 测试环境
  if (location.host.indexOf('test') > -1) {
    return 'http://open.test.jiehun.com.cn/common/wechat/get-init-weixin'
    // beta及正式环境
  } else {
    return 'https://open.jiehun.com.cn/common/wechat/get-init-weixin'
  }
}
/**
 *
 * String isShow:是否显示，1:显示，2:隐藏
 * String title：按钮名称
 */
function navBtnR(isShow, title) {
  HBHGlobal = this
  AppCalls.callapp(
    'ui_navigation_right_btn',
    {
      isShow: isShow,
      title: title,
      iconUrl:
        'https://img.hbhcdn.com/dmp/other/1547481600/jh-img-orig-ga_1085044131768991744_200_200_3547.png'
    },
    'HBHGlobal.appRightTopShare'
  )
}

/**
 * app内右上角分享
 */
function appRightTopShare() {
  // 分享
  var shareUrl = location.origin + '/shiguangji/index.html'

  var contentText = '我是一只会开时光机的时光鸡，能带你遇见未来哦'
  var args = {
    title: '爱情时光机',
    content: contentText,
    message: contentText,
    url: shareUrl,
    img_url:
      'https://img.hbhcdn.com/dmp/other/1551888000/jh-img-orig-ga_1103565256534687744_60_60_2588.png'
  }

  AppCalls.callapp('ui_share', args, '')
}

// const DEV_MODE = true // 开发模式
const DEV_MODE = false // 正式发布

function getUrlParam(name) {
	var reg = new RegExp("(^|&)" + name + "=([^&]*)(&|$)")
	var r = window.location.search.substr(1).match(reg)
  if (r != null) {
    return unescape(r[2])
  }
  return null
}

// 设置当前Cookie
function setCookie(name, value, expiredays) {
  var exdate = new Date()
  exdate.setDate(exdate.getDate() + expiredays)
  document.cookie =
    name +
    '=' +
    escape(value) +
    (expiredays == null ? '' : ';expires=' + exdate.toGMTString())
}

//判断是否是微信浏览器的函数
function isWeiXin() {
  //window.navigator.userAgent属性包含了浏览器类型、版本、操作系统类型、浏览器引擎类型等信息，这个属性可以用来判断浏览器类型
  var ua = window.navigator.userAgent.toLowerCase()
  //通过正则表达式匹配ua中是否含有MicroMessenger字符串
  if (ua.match(/MicroMessenger/i) == 'micromessenger') {
    return true
  } else {
    return false
  }
}

/**
 * 获取微信配置
 */
function weixinInit(href, wx) {
  var that = this
  var params = {
    type: 'hunbasha',
    user_agent: 'MicroMessenger_rer',
    authUrl: href
  }
  // 微信授权
  axios
    .post(that.getWxConfigUrl(), params, {
      headers: {
        'Content-Type': 'application/json;charset=utf-8',
        Authorization: that.getCookie('Authorization')
      }
    })
    .then(function(response) {
      var data = response.data.data
      wx.config({
        debug: false, // 开启调试模式,调用的所有api的返回值会在客户端alert出来，若要查看传入的参数，可以在pc端打开，参数信息会通过log打出，仅在pc端时才会打印。
        appId: data.data.appId, // 必填，公众号的唯一标识appId
        timestamp: data.data.timestamp + '', // 必填，生成签名的时间戳
        nonceStr: data.data.nonceStr, // 必填，生成签名的随机串
        signature: data.data.signature, // 必填，签名
        jsApiList: ['onMenuShareTimeline', 'onMenuShareAppMessage'] // 必填，需要使用的JS接口列表
      })
      wx.ready(function() {
        var link = location.origin + '/shiguangji/index.html'
        var imgUrl =
          'https://img.hbhcdn.com/dmp/other/1551888000/jh-img-orig-ga_1103565256534687744_60_60_2588.png'
        //分享朋友圈
        wx.onMenuShareTimeline({
          title: '惊！我今天被一只时光鸡带到了2029年',
          link: link,
          imgUrl: imgUrl, // 自定义图标
          trigger: function() {},
          success: function() {},
          cancel: function() {},
          fail: function() {}
        })
        //分享给好友
        wx.onMenuShareAppMessage({
          title: '爱情时光机', // 分享标题
          desc: '我是一只会开时光机的时光鸡，能带你遇见未来哦', // 分享描述
          link: link, // 分享链接，该链接域名或路径必须与当前页面对应的公众号JS安全域名一致
          imgUrl: imgUrl, // 自定义图标
          type: 'link', // 分享类型,music、video或link，不填默认为link
          dataUrl: '', // 如果type是music或video，则要提供数据链接，默认为空
          // 用户确认分享后执行的回调函数
          success: function() {},
          // 用户取消分享后执行的回调函数
          cancel: function() {}
        })
        wx.error(function() {})
      })
    })
    .catch(function() {})
}

// 设置rem
function setPhoneRem() {
  //window.navigator.userAgent属性包含了浏览器类型、版本、操作系统类型、浏览器引擎类型等信息，这个属性可以用来判断浏览器类型
  var ua = window.navigator.userAgent.toLowerCase()
  var remSize
  // 判断是否锤子坚果Pro2手机并在在微信浏览器
  if (
    ua.indexOf('os105') > -1 &&
    ua.match(/MicroMessenger/i) == 'micromessenger' &&
    window.screen.width == 432
  ) {
    remSize = (window.screen.width / 37.5 / 3) * 4 + 'px'
  } else {
    remSize = window.screen.width / 37.5 + 'px'
  }
  return remSize
}

export default {
  refs,
  getCookie,
  getUrlParam,
  setCookie,
  isWeiXin,
  getUrlDomainForShiguangji,
  getWxConfigUrl,
  weixinInit,
  navBtnR,
  appRightTopShare,
  setPhoneRem,

  DEV_MODE
}
</script>
